module.exports = __webpack_public_path__ + "img/zap.b029ec67.svg";